/**
 * Whether a paid action can start: free actions and admins in bypass mode pay nothing,
 * everyone else needs the cost in credits. While the balance is still loading the server decides.
 */
export function creditCostState(
  balance: number | undefined,
  cost: number,
  bypass: boolean,
): 'free' | 'enough' | 'short' | 'unknown' {
  if (bypass || cost <= 0) return 'free'
  if (balance === undefined) return 'unknown'
  return balance >= cost ? 'enough' : 'short'
}

export type CreditCostState = ReturnType<typeof creditCostState>
